import React from "react";
import "../styles/components/button.css";

const Button = ({ text, icon, styleType = "green", onClick }) => {
  const buttonClass = styleType === "green" ? "btn btn-green" : "btn btn-white";

  return (
    <button className={buttonClass} onClick={onClick}>
      {icon && <img src={icon} alt="icon" className="btn-icon" />}
      {text && <span className="btn-text">{text}</span>}
    </button>
  );
};

export default Button;
